<template>
  <div id="jumbotron" class="row m-0">
    <div id="bubble" class="col-12 col-md-4 col-lg-3 d-none d-md-block">
      <div class="text text-center">
        <div class="title tf-dm-serif text-secondary">100%</div>
        <p v-html="$t('homePage.jumbotron.passingRate')">
        </p>
      </div>
    </div>
    <div id="welcome" class="col-12 col-md-8 col-lg-9">
      <h1 class="mt-5 pt-5">
        {{ $t('homePage.jumbotron.tagLine') }}
        <br>{{ $t('homePage.jumbotron.subTagLine') }}</h1>
      <p>{{ $t('homePage.jumbotron.help') }}</p>
      <div>
        <router-link class="btn btn-secondary me-4 px-4" to="/our-programs">
          {{ $t('homePage.jumbotron.programs') }}
        </router-link>
        <router-link class="btn btn-primary px-4" to="/about-english-matters">
          {{ $t('homePage.jumbotron.about') }}
        </router-link>
      </div>
    </div>
  </div>

  <div id="about" class="text-center py-5">
    <p class="fw-bold text-secondary">
      {{ $t('homePage.about.title') }}
    </p>
    <p class="container" style="max-width: 800px" v-html="$t('homePage.about.content')">
    </p>
    <p class="fw-bold text-secondary">
      {{ $t('homePage.about.igcse_ready') }}
    </p>
    <br><br><br>
    <div class="text-start">
      <WhyUs />
    </div>
    <br><br><br><br>
    <h2 class="text-primary" v-html="$t('homePage.limits.title')">
    </h2>
    <Carousel v-bind="carouselConfig">
      <Slide v-for="slide in slides" :key="slide">
        <img class="carousel__item" :src="slide" height="300px" width="225px">
      </Slide>
    </Carousel>
  </div>
  
  <div id="classes" class="text-center pb-5">
    <p class="fw-bold text-secondary">
      {{ $t('homePage.classes.subtitle') }}
    </p>
    <br>
    <h2 class="text-primary" v-html="$t('homePage.classes.title')">
    </h2>
    <div class="row justify-content-center mx-auto">
      <div class="col-12 col-md-4 p-4">
        <div class="year bg-white p-4">
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/chat-bubble-1.png" alt="Year 5-11 english classes" class="mx-auto py-3">
          <div class="heading text-secondary">5-11</div>
          <p class="sub-heading">{{ $t('homePage.classes.years') }}</p>
          <p class="description">
            {{ $t('homePage.classes.primaryDescription') }}
          </p>
          <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/english-class-for-5-11-years-old-kids/">
            {{ $t('homePage.classes.learnMore') }}
          </router-link>
        </div>
      </div>
      <div class="col-12 col-md-4 p-4">
        <div class="year bg-white p-4">
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/chat-bubble-2.png" alt="Year 12-19 english classes" class="mx-auto py-3">
          <div class="heading text-secondary">12-19</div>
          <p class="sub-heading">{{ $t('homePage.classes.years') }}</p>
          <p class="description">
            {{ $t('homePage.classes.secondaryDescription') }}
          </p>
          <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/english-class-for-12-19-years-old-kids/">
            {{ $t('homePage.classes.learnMore') }}
          </router-link>
        </div>
      </div>
      <div class="col-12 col-md-4 p-4">
        <div class="year bg-white p-4">
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/chat-bubble-3.png" alt="Adult english classes" class="mx-auto py-3">
          <div class="heading text-secondary">
            {{ $t('homePage.classes.adultTitle') }}
          </div>
          <p class="sub-heading">{{ $t('homePage.classes.years') }}</p>
          <p class="description">
            {{ $t('homePage.classes.adultDescription') }}
          </p>
          <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/english-class-for-adults/">
            {{ $t('homePage.classes.learnMore') }}
          </router-link>
        </div>
      </div>
      <div class="col-12 col-md-8 p-4">
        <div class="year bg-white p-4">
          <div class="heading text-secondary" style="font-size: 3.5em;">
            {{ $t('homePage.classes.creativeWritingTitle') }}
          </div>
          <p class="sub-heading">
            {{ $t('homePage.classes.creativeWritingAge') }}
          </p>
          <p class="description mx-auto" style="max-width: 360px;">
            {{ $t('homePage.classes.creativeWritingDescription') }}
          </p>
          <router-link class="btn btn-primary px-4 py-2 my-4" to="/english-classes/school-holidays-english-class/">
            {{ $t('homePage.classes.learnMore') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>

  <div id="testimonials" class="container py-5">
    <h4 class="text-primary text-center">
      {{ $t('homePage.testimony.title') }}
    </h4>

    <div class="row m-0">
      <div class="col-12 col-sm-6 col-md-4 p-4">
        <div class="testimony">
          <p>{{ $t('homePage.testimony.first.testimony') }}</p>
          <div class="author text-secondary">{{ $t('homePage.testimony.first.name') }}</div>
          <div class="author-details">{{ $t('homePage.testimony.first.description') }}</div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 p-4">
        <div class="testimony">
          <p>{{ $t('homePage.testimony.second.testimony') }}</p>
          <div class="author text-secondary">{{ $t('homePage.testimony.second.name') }}</div>
          <div class="author-details">{{ $t('homePage.testimony.second.description') }}</div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 p-4">
        <div class="testimony">
          <p>{{ $t('homePage.testimony.third.testimony') }}</p>
          <div class="author text-seconrdary">{{ $t('homePage.testimony.third.name') }}</div>
          <div class="author-details">{{ $t('homePage.testimony.third.description') }}</div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 p-4">
        <div class="testimony">
          <p>{{ $t('homePage.testimony.fourth.testimony') }}</p>
          <div class="author text-secondary">{{ $t('homePage.testimony.fourth.name') }}</div>
          <div class="author-details">{{ $t('homePage.testimony.fourth.description') }}</div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 p-4">
        <div class="testimony">
          <p>{{ $t('homePage.testimony.fifth.testimony') }}</p>
          <div class="author text-secondary">{{ $t('homePage.testimony.fifth.name') }}</div>
          <div class="author-details">{{ $t('homePage.testimony.fifth.description') }}</div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 p-4">
        <div class="testimony">
          <p>{{ $t('homePage.testimony.sixth.testimony') }}</p>
          <div class="author text-secondary">{{ $t('homePage.testimony.sixth.name') }}</div>
          <div class="author-details">{{ $t('homePage.testimony.sixth.description') }}</div>
        </div>
      </div>
    </div>
  </div>

  <div id="prospectus">
    <div class="container text-center text-md-start">
      <p class="fw-bold text-secondary">
        {{ $t('homePage.prospectus.title') }}
      </p>
      <h4 class="text-primary">
        {{ $t('homePage.prospectus.year') }}
      </h4>
      <a href="https://english-matters.s3.ap-southeast-1.amazonaws.com/files/English+Matters+2025+Program+Brochure.pdf" 
        target="_blank"
        class="btn btn-primary">{{ $t('homePage.prospectus.cta') }}</a>
    </div>
  </div>

  <div id="history">
    <div class="container">
      <div class="row m-0">
        <div class="col-12 col-md-6">
          <div class="sub-container-1">
            <h4 class="text-secondary text-center">1999</h4>
            <p class="text-primary tf-dm-serif">
              {{ $t('homePage.history.subTitle') }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="sub-container-2">
            <p class="text-primary"><strong>
              {{ $t('homePage.history.contentOne') }}
            </strong></p>
            <p>
              {{ $t('homePage.history.contentTwo') }}
            </p>

            <router-link class="btn btn-primary px-4 mt-4" to="/about-english-matters">
              {{ $t('homePage.history.learnMore') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  // If you are using PurgeCSS, make sure to whitelist the carousel CSS classes
  import 'vue3-carousel/carousel.css'
  import { Carousel, Slide } from 'vue3-carousel'

  const carouselConfig = {
    itemsToShow: 1,
    wrapAround: true,
    autoplay: 3000,
    snapAlign: 'center',
    height: '400px',
    gap: 5,
    breakpoints: {
      0: { itemsToShow: 1 },
      500: { itemsToShow: 2 },
      768: { itemsToShow: 3 },
      1200: { itemsToShow: 5 },
    }
  }
</script>

<script>
  import WhyUs from '../components/WhyUs.vue';
  export default {
    components: { WhyUs },
    data() {
      return {
        slides: [
          "https://english-matters.s3.ap-southeast-1.amazonaws.com/carousel/Nas+with+student.webp",
          "https://english-matters.s3.ap-southeast-1.amazonaws.com/carousel/Student+Discussion.webp",
          "https://english-matters.s3.ap-southeast-1.amazonaws.com/carousel/Word+games.webp",
          "https://english-matters.s3.ap-southeast-1.amazonaws.com/carousel/Happy+students.webp",
          "https://english-matters.s3.ap-southeast-1.amazonaws.com/carousel/Student+Discussion+2.webp"
        ]
      };
    }
  };
</script>

<style scoped>
  #jumbotron {
    background-color: #2e1aaf;
    min-height: 85vh;
    background-image: url('https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/jumbotron.png');
    background-position: right bottom -200px;
    background-repeat: no-repeat;
    background-size: 100vw auto;
    width: 100%;
    color: white;
  }
  @media (max-width: 800px) {
    #jumbotron {
      background-position: right bottom;
    }
  }

  #bubble {
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/bubble.png");
    background-position: left -145px top 100px;
    background-repeat: no-repeat;
    background-size: 400px;
  }
  #bubble .text {
    margin-top: 110px;
    margin-left: 85px;
    width: 130px;
  }
  #bubble .title {
    font-size: 2.5em;
  }
  #bubble p {
    font-size: 0.9em;
    color: #21147c;
  }

  #welcome { margin-top: 10vh; padding-bottom: 10vh; }
  #welcome h1 { font-size: 4em; }
  #welcome p { font-size: 1.8em; }

  #about h2 { font-size: 3.5em; }
  #about p { font-size: 1.2em; }

  #classes {
    background-color: #F4F3F9;
    margin-top: -150px;
    padding-top: 200px;
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/human-bubble-2.png");
    background-position: right -10px top 400px;
    background-repeat: no-repeat;
    background-size: 1600px;
  }
  #classes h2 { font-size: 3.5em; }
  #classes p { font-size: 1.2em; }
  #classes .year { border-radius: 15px; }
  #classes .year .heading { 
    font-size: 5em; 
    font-weight: 400;
    font-family: "DM Serif Display", serif;
  }
  #classes .row {
    max-width: 1200px;
  }
  #classes .year .sub-heading { 
    font-size: 1.2em; 
    color: #B2Aecc;
    font-weight: 700;
  }

  #testimonials { max-width: 1100px; }
  #testimonials h4 { font-size: 2.5em; }
  #testimonials .testimony {
    padding: 24px 48px 24px 24px;
    background-position: 95% 8px;
    background-repeat: no-repeat;
    background-size: 40px auto;
    border-style: solid;
    border-width: 5px 5px 5px 5px;
    border-color: #F4F3F9;
    border-radius: 25px 25px 25px 25px;
    height: 100%;
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/quote-symbol.webp");
    background-position: right 10px top 10px;
    background-repeat: no-repeat;
  }
  #testimonials .testimony .author {
    font-weight: bold;
  }
  #testimonials .testimony .author-details {
    font-style: italic;
    font-size: 0.9em;
  }

  #prospectus {
    background-color: #F4F3F9;
    min-height: 500px;
    padding-top: 200px;
    padding-bottom: 200px;
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/consultation.png");
    background-position: left bottom;
    background-repeat: no-repeat;
  }
  #prospectus .container {
    max-width: 1000px;
  }
  #prospectus h4 { font-size: 3.5em; }
  #prospectus p { font-size: 1.2em; }

  #history {
    min-height: 700px;
    padding-top: 100px;
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/discussion.png");
    background-position: left bottom 20px;
    background-repeat: no-repeat;
  }
  @media (max-width: 1200px) {
    #history {
      background-image: none;
    }
  }
  #history .sub-container-1 {
    max-width: 450px;
    margin: auto;
  }
  #history .sub-container-1 h4 { font-size: 8em; }
  #history .sub-container-1 p { font-size: 1.5em; }
  #history .sub-container-2 {
    padding: 4em 0;
    max-width: 300px;
    margin: auto;
  }
</style>
